'use strict';

var jsxRuntime = require('react/jsx-runtime');
var react = require('react');
var translation = require('@templafy/translation');
var icons_IconView = require('../../icons/IconView.js');
var icons_IconHidden = require('../../icons/IconHidden.js');
var BaseTextInput = require('../../_chunks/BaseTextInput-CHJ9_GE-.js');
var FieldContext = require('../../_chunks/FieldContext-DI94tJqT.js');
var hooks_useUUID = require('../../hooks/useUUID.js');
var components_visuallyHidden_VisuallyHidden = require('../visuallyHidden/VisuallyHidden.js');
var hooks_useCombinedRefs = require('../../hooks/useCombinedRefs.js');
require('../../icons/Icon.js');
require('../../_chunks/combineClasses-5P8GTQkg.js');
require('../../_chunks/index-CIVOGJRG.js');
require('../../_chunks/designTokens-CKP-YoT2.js');
require('../../_chunks/useInputAccessibilityProps-uzRyF5PP.js');
require('../../utilities/createComponentNamespace.js');
require('../../utilities/a11yIgnore.js');
require('../../_chunks/BaseButton-DDcpn9-P.js');
require('../../_chunks/useDevelopmentEffect-DGG0KnB_.js');
require('../../icons/IconLoading.js');
require('../form/FormContext.js');

const PasswordInput = react.forwardRef(({ testId, className, style, onChange, id: idProperty, disabled: _disabled, readOnly: _readOnly, required: _required, size: _size, status: _status, ...props }, ref) => {
    const translator = translation.useTranslator();
    const { disabled, readOnly, required, size, status } = FieldContext.useSynchronizedProps({
        disabled: _disabled,
        readOnly: _readOnly,
        required: _required,
        size: _size,
        status: _status,
        inputType: 'text',
    });
    const buttonRef = react.useRef(null);
    const inputRef = react.useRef(null);
    const combinedInputRef = hooks_useCombinedRefs.useCombinedRefs(inputRef, ref);
    const [isPasswordShown, setIsPasswordShown] = react.useState(false);
    const fieldContext = FieldContext.useFieldContext();
    const id = hooks_useUUID.useUUID({
        idOverride: idProperty ?? fieldContext?.inputId,
        prefix: 'password',
    });
    return (jsxRuntime.jsx(BaseTextInput.BaseTextInputNamespace, { type: isPasswordShown ? 'text' : 'password', onValueChange: onChange, disabled: disabled, readOnly: readOnly, required: required, size: size, status: status, wrapperProps: {
            testId,
            className,
            style,
            onBlur: (event) => {
                if (!event.relatedTarget ||
                    ![inputRef.current, buttonRef.current].includes(event.relatedTarget)) {
                    // if the focus moves outside of the input wrapper then switch the input back to be a password field
                    // to make sure that it's not saved for autocompletion when the form is submitted
                    setIsPasswordShown(false);
                }
            },
        }, ...props, id: id, ref: combinedInputRef, endAdornment: jsxRuntime.jsxs(jsxRuntime.Fragment, { children: [jsxRuntime.jsx(BaseTextInput.BaseTextInputNamespace.AdornmentButton, { disabled: disabled || readOnly, "aria-label": translator.uiComponentsPasswordInputVisibilityButtonLabel({ isPasswordShown: isPasswordShown ? 'true' : 'false' }), "aria-controls": id, preventFocusOnClick: 
                    // the button needs to be focused when clicked so clicking away will trigger a blur and hide the password
                    false, icon: isPasswordShown ? icons_IconHidden.IconHidden : icons_IconView.IconView, onClick: () => setIsPasswordShown(!isPasswordShown), ref: buttonRef, testId: "reveal-password" }), jsxRuntime.jsx(components_visuallyHidden_VisuallyHidden.VisuallyHidden, { "aria-live": "polite", "aria-atomic": true, "data-testid": "live-text", children: translator.uiComponentsPasswordInputVisibilityStatus({
                        isPasswordShown: isPasswordShown ? 'true' : 'false',
                    }) })] }) }));
});
PasswordInput.displayName = 'PasswordInput';

exports.PasswordInput = PasswordInput;
//# sourceMappingURL=PasswordInput.js.map
